import { AgrupamentoStringboxCD } from "./agrupamento-stringbox-cd";
import { AgrupamentoStringboxItem } from "./agrupamento-stringbox-item";

export class AgrupamentoStringbox {
  id: number;
  idInversor: number;
  descricaoInversor: string;
  idMarca: number;
  descricaoMarca: string;
  descricao: string;
  ativo: boolean;

  itens: AgrupamentoStringboxItem[];
  cds: AgrupamentoStringboxCD[];

  imagem$: any;
  buscouImagem: boolean;
}
